import { DataConfigType } from 'routes/logged-in/collection-data-configs/CreateCollectionDataConfigRoute';
import { useActions } from 'utils/connect';
import LuceneDataConfigForm, {
  LuceneDataConfigValues,
  getDataConfigurationFromValues,
  luceneDataConfigEmptyState,
} from 'components/consumer-widget-data-configs/lucene-data-config/LuceneDataConfigForm';

interface Props {
  onCompleteOrCancel(): void;
  dataConfigType: DataConfigType;
}

const CreateLuceneDataConfigForm: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  onCompleteOrCancel,
  dataConfigType,
}) => {
  const { actions } = useActions();

  const handleSubmit = (values: LuceneDataConfigValues) => {
    return actions.consumerPage
      .createDataConfiguration(getDataConfigurationFromValues(values, dataConfigType))
      .then(() => actions.consumerPage.fetchAllCollectionDataConfigurations('ALL'))
      .then(onCompleteOrCancel);
  };

  return (
    <LuceneDataConfigForm
      dataConfigType={dataConfigType}
      onCancel={onCompleteOrCancel}
      initialValues={luceneDataConfigEmptyState}
      onSubmit={handleSubmit}
    />
  );
};

export default CreateLuceneDataConfigForm;
